import React from 'react';
import IdleTimerContainer from './modules/layout/containers/IdleTimerContainer';

function App() {
  return (
      <IdleTimerContainer />
  )
}

export default App;